import { Gauge, gaugeClasses } from "@mui/x-charts";

const settings = {
  width: 80,
  height: 80,
};

export const ChartPercentage = ({ value }) => {
  const valueNum = Number(value);
  return (
    <Gauge
      {...settings}
      value={valueNum}
      cornerRadius="50%"
      text={({ value }) => `${value}%`}
      sx={(theme) => ({
        [`& .${gaugeClasses.valueText}`]: {
          fontSize: 12,
        },
        [`& .${gaugeClasses.valueArc}`]: {
          fill: "#343745",
        },
        [`& .${gaugeClasses.referenceArc}`]: {
          fill: theme.palette.text.disabled,
        },
      })}
    />
  );
};
